import { LineInterface } from '../Interfaces/Draft/LineInterface'
import { InvoiceItemType } from "../Interfaces/Draft/DraftItemType";
import { SubtotalLineInterface } from "../Interfaces/Draft/SubtotalLineInterface";
import { TitleLineInterface } from "../Interfaces/Draft/TitleLineInterface";

export abstract class Type {
  public static isArray(arg: any): arg is any[] {
    return (arg !== null && typeof arg.pop !== 'undefined');
  }

  public static isObject(arg: any): arg is Object {
    if (arg === null) {
      return false;
    }
    return typeof arg === 'object';
  }

  public static isInvoiceLine(arg: InvoiceItemType): arg is LineInterface {
    return arg['type'] === 'row';
  }

  public static isInvoiceSubtotalLine(arg: InvoiceItemType): arg is SubtotalLineInterface {
    return arg['type'] === 'subtotal';
  }

  public static isInvoiceTitleLine(arg: InvoiceItemType): arg is TitleLineInterface {
    return arg['type'] === 'title';
  }

}
